export function normalizePhoneForDb(raw: string | null | undefined): string | null {
  const s = String(raw || "").trim();
  if (!s) return null;
  // Keep permissive: ensure non-empty and collapse whitespace.
  const cleaned = s.replace(/\s+/g, " ");
  return cleaned.length ? cleaned : null;
}

